import React, { useState } from "react";
import Modal1 from "../../../components/DIsplay/Modal/Modal1";
import { MdLink, MdDelete, MdWarning } from "react-icons/md";

function WhitelistDomainList({ domains = [], onDelete }) {
  const [open, setOpen] = useState(false);
  const [selectedDomain, setSelectedDomain] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleOpenConfirm = (domain) => {
    setSelectedDomain(domain);
    setOpen(true);
  };

  const handleClose = () => {
    setSelectedDomain(null);
    setOpen(false);
    setLoading(false);
  };

  const handleConfirmDelete = async () => {
    if (!selectedDomain) return;
    setLoading(true);
    await onDelete?.(selectedDomain);
    setLoading(false);
    handleClose();
  };

  if (!domains.length) {
    return (
      <div className="rounded-xl border border-outline bg-white p-4 text-sm text-gray-500">
        No whitelisted domains yet.
      </div>
    );
  }

  return (
    <>
      {/* DOMAIN LIST */}
      <div className="rounded-2xl border border-outline bg-white divide-y">
        {domains.map((domain, idx) => (
          <div
            key={idx}
            className="flex items-center justify-between px-4 py-3"
          >
            <div className="flex items-center gap-3 min-w-0">
              <div className="w-9 h-9 rounded-lg bg-primary/10 flex items-center justify-center shrink-0">
                <MdLink className="text-primary text-lg" />
              </div>
              <span className="text-sm font-medium text-gray-900 truncate">
                {domain}
              </span>
            </div>

            <button
              type="button"
              onClick={() => handleOpenConfirm(domain)}
              className="flex items-center gap-1 text-sm font-semibold text-red-600 hover:opacity-80"
            >
              <MdDelete className="text-lg" />
              Delete
            </button>
          </div>
        ))}
      </div>

      {/* CONFIRM DELETE MODAL */}
      <Modal1 open={open} setOpen={setOpen}>
        <div className="w-full max-w-sm bg-white rounded-2xl p-5 flex flex-col gap-4">
          <div className="flex items-start gap-3">
            <div className="w-10 h-10 rounded-xl bg-red-50 flex items-center justify-center">
              <MdWarning className="text-red-600 text-xl" />
            </div>
            <div className="flex flex-col">
              <span className="font-semibold text-gray-900">
                Remove whitelisted domain
              </span>
              <span className="text-sm text-gray-500">
                This domain will no longer have admin access.
              </span>
            </div>
          </div>

          <div className="rounded-lg bg-gray-50 px-4 py-3 text-sm font-medium text-gray-800">
            {selectedDomain}
          </div>

          <div className="flex justify-end gap-3 pt-2">
            <button
              type="button"
              onClick={handleClose}
              className="px-4 py-2 rounded-md bg-gray-100 font-semibold text-sm"
            >
              Cancel
            </button>

            <button
              type="button"
              onClick={handleConfirmDelete}
              disabled={loading}
              className={`w-[120px] h-[44px] rounded-md font-bold text-sm flex items-center justify-center ${
                loading
                  ? "bg-red-300 text-white"
                  : "bg-red-600 text-white hover:opacity-90"
              }`}
            >
              {loading ? <div className="buttonLoader"></div> : "Delete"}
            </button>
          </div>
        </div>
      </Modal1>
    </>
  );
}

export default WhitelistDomainList;
